import React from 'react';

export const LuckyWheelNeedle = ({ width, className }) => {
    return (
        <svg
            width="36"
            height="46"
            viewBox="0 0 36 46"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={className}
        >
            <defs>
                <filter
                    x="-25%"
                    y="-23.7%"
                    width="150%"
                    height="136.8%"
                    filterUnits="objectBoundingBox"
                    id="ec6i9d3ufb"
                >
                    <feOffset dy="-2" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" in="shadowBlurOuter1" />
                </filter>
                <filter
                    x="-21.4%"
                    y="-15.8%"
                    width="142.9%"
                    height="131.6%"
                    filterUnits="objectBoundingBox"
                    id="k1wcok6x2e"
                >
                    <feGaussianBlur stdDeviation="4" in="SourceAlpha" result="shadowBlurInner1" />
                    <feOffset dy="4" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite
                        in="shadowOffsetInner1"
                        in2="SourceAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                        result="shadowInnerInner1"
                    />
                    <feColorMatrix
                        values="0 0 0 0 0.813142417 0 0 0 0 0.109314998 0 0 0 0 0.0719135414 0 0 0 1 0"
                        in="shadowInnerInner1"
                    />
                </filter>
                <filter
                    x="-10.7%"
                    y="-7.9%"
                    width="121.4%"
                    height="115.8%"
                    filterUnits="objectBoundingBox"
                    id="iw6vxfatmf"
                >
                    <feGaussianBlur stdDeviation="1" in="SourceGraphic" />
                </filter>
                <filter
                    x="-26.9%"
                    y="-41%"
                    width="153.8%"
                    height="182%"
                    filterUnits="objectBoundingBox"
                    id="036d30sbfh"
                >
                    <feGaussianBlur stdDeviation="1" in="SourceGraphic" />
                </filter>
                <path
                    d="M14 38c7.732 0 14-6.15 14-13.735C28 16.68 17 0 14 0S0 16.68 0 24.265C0 31.851 6.268 38 14 38z"
                    id="i6vrl05xja"
                />
                <path
                    d="M14 38c7.732 0 14-6.15 14-13.735C28 16.68 17 0 14 0S0 16.68 0 24.265C0 31.851 6.268 38 14 38z"
                    id="c7rhcctx3d"
                />
                <linearGradient x1="100%" y1="28.48%" x2="0%" y2="65.792%" id="pi0gflkvgg">
                    <stop stopColor="#FFF" stopOpacity="0" offset="0%" />
                    <stop stopColor="#FFF" offset="47.858%" />
                    <stop stopColor="#FFF" stopOpacity="0" offset="100%" />
                </linearGradient>
            </defs>
            <g transform="rotate(180 16 20)" fill="none" fillRule="evenodd">
                <mask id="lc0kpy1orc" fill="#fff">
                    <use xlinkHref="#i6vrl05xja" />
                </mask>
                <use filter="url(#ec6i9d3ufb)" xlinkHref="#i6vrl05xja" fill="#000" />
                <g mask="url(#lc0kpy1orc)">
                    <use fill="#FF3025" xlinkHref="#c7rhcctx3d" />
                    <use fill="#000" filter="url(#k1wcok6x2e)" xlinkHref="#c7rhcctx3d" />
                </g>
                <path
                    d="M14 .5c.736 0 1.947 1.2 3.363 2.89 1.634 1.951 3.493 4.658 5.17 7.566 2.71 4.697 4.967 9.922 4.967 13.31 0 3.653-1.51 6.96-3.95 9.354A13.594 13.594 0 0 1 14 37.5a13.594 13.594 0 0 1-9.55-3.88C2.01 31.226.5 27.92.5 24.265c0-3.387 2.256-8.612 4.966-13.309 1.678-2.908 3.537-5.615 5.171-7.565C12.053 1.7 13.264.5 14 .5z"
                    stroke="#9D0000"
                    filter="url(#iw6vxfatmf)"
                    mask="url(#lc0kpy1orc)"
                />
                <path
                    d="M9.125 31.764A10.147 10.147 0 0 0 14 33c5.523 0 10-4.37 10-9.759"
                    stroke="url(#pi0gflkvgg)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    filter="url(#036d30sbfh)"
                    mask="url(#lc0kpy1orc)"
                />
            </g>
        </svg>
    );
};
